import { render, staticRenderFns } from "./SitchDataTableInfo.vue?vue&type=template&id=7dceaf3f&scoped=true&"
import script from "./SitchDataTableInfo.vue?vue&type=script&lang=ts&"
export * from "./SitchDataTableInfo.vue?vue&type=script&lang=ts&"
import style0 from "./SitchDataTableInfo.vue?vue&type=style&index=0&id=7dceaf3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dceaf3f",
  null
  
)

export default component.exports